export type EntryMode = 'new-site' | 'existing-site';

export const ENTRY_MODE = {
  NewSite: 'new-site',
  ExistingSite: 'existing-site',
} as const;

export const ENTRY_PARAM = 'entry';
export const EXISTING_SITE_ENTRY_PARAM_VALUE = 'existing';

export function getEntryModeFromWindow(): EntryMode {
  return window.__ENTRY_MODE__ ?? ENTRY_MODE.NewSite;
}

export function isExistingSiteEntryMode(entryMode: EntryMode): boolean {
  return entryMode === ENTRY_MODE.ExistingSite;
}

export function getEntryParamValue(entryMode: EntryMode): string | undefined {
  return isExistingSiteEntryMode(entryMode) ? EXISTING_SITE_ENTRY_PARAM_VALUE : undefined;
}
